import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Container as Button } from '../buttons/Button.style';
import { Container as DropButton } from '../buttons/DropButton.style';
import { Container as SelectInput } from '../inputs/SelectInput.style';
import { Input } from '../inputs/TextInput.style';

export const Container = styled.form`
  background-color: ${({ theme }) => theme.background};
  border-radius: 4px;
  width: 100%;
  padding: 10px;

  ${Input} {
    height: 46px;
  }
`;

export const LowerRow = styled.div`
  display: flex;
  margin-top: 5px;

  ${Button} {
    max-width: 140px;
    height: 42px;
    margin-left: 5px;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;

    ${Button} {
      margin-top: 5px;
      max-width: none;
      margin-left: 0;
    }
  }
`;

const Mask = css`
  content: '';
  position: absolute;
  top: 1px;
  bottom: 1px;
  width: 1px;
  background-color: ${({ theme }) => theme.white};
`;

export const ArrivalRow = styled.div<{ $dayError: boolean; $timeError: boolean; $isDrive: boolean }>`
  display: flex;
  margin-top: 5px;

  ${DropButton} {
    position: relative;
  }

  ${({ $isDrive, $dayError, $timeError }) =>
    !$isDrive
      ? css`
          ${SelectInput}:first-child {
            ${DropButton} {
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              &:before {
                ${!$dayError
                  ? css`
                      ${Mask}
                      right: 0;
                    `
                  : ''}
              }
            }
          }
          ${SelectInput}:nth-child(2) {
            ${DropButton} {
              border-top-left-radius: 0px;
              border-bottom-left-radius: 0px;
              &:before {
                ${!$timeError
                  ? css`
                      ${Mask}
                      left: 0;
                    `
                  : ''}
              }
            }
          }
        `
      : ''}

  @media (${mobileXXLargeMax}) {
    ${SelectInput} {
      span,
      svg {
        font-size: 14px !important;
      }
    }

    ${Button} {
      margin-left: 5px;
    }
  }
`;

export const TravelOption = styled.button<{ active?: boolean }>`
  width: 42px;
  height: 42px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.backgroundMid};
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (${mobileXXLargeMax}) {
    flex: 1;

    &:last-child {
      margin-right: 0;
      margin-bottom: 5px;
    }
  }

  &:hover {
    background-color: ${({ theme }) => theme.textLight};
  }

  ${({ theme, active }) =>
    active &&
    `
    background-color: ${theme.primary};
    
     &:hover {
      background-color: ${theme.primary};
    }
  `}
`;
